import { HTMLAttributes } from "react";
import { cn } from "../../../helper/Utilities";

type Props = HTMLAttributes<HTMLDivElement> & {
};

export default function FormError({ children, className, style, ...props }: Props) {
  return (
    <>
      {
        children &&
        <div className={cn('ml-2 text-sm text-red h-5', className)} style={{ minHeight: "1.3rem", ...style }} {...props}>
          {children}
        </div>
      }
    </>
  );
}
